export default {"src":"/_next/static/media/icon_footer_home.b2c8f8af.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};